const icon = {
  hyRaf: `<svg width="35" height="35" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 13.5455V16.8182L12.5636 19.3545" stroke="#111111" stroke-miterlimit="10"/>
    <path d="M16 16.8182L19.4364 19.3545" stroke="#111111" stroke-miterlimit="10"/>
    <path d="M16 13.5455C17.8075 13.5455 19.2727 12.0802 19.2727 10.2727C19.2727 8.46525 17.8075 7 16 7C14.1925 7 12.7273 8.46525 12.7273 10.2727C12.7273 12.0802 14.1925 13.5455 16 13.5455Z" stroke="#111111" stroke-miterlimit="10" stroke-linecap="square"/>
    <path d="M10.2727 25C12.0802 25 13.5455 23.5347 13.5455 21.7273C13.5455 19.9198 12.0802 18.4545 10.2727 18.4545C8.46525 18.4545 7 19.9198 7 21.7273C7 23.5347 8.46525 25 10.2727 25Z" stroke="#111111" stroke-miterlimit="10" stroke-linecap="square"/>
    <path d="M21.7273 25C23.5348 25 25 23.5347 25 21.7273C25 19.9198 23.5348 18.4545 21.7273 18.4545C19.9198 18.4545 18.4546 19.9198 18.4546 21.7273C18.4546 23.5347 19.9198 25 21.7273 25Z" stroke="#111111" stroke-miterlimit="10" stroke-linecap="square"/>
    </svg>`,
  hyMail: `<svg width="37" height="36" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.1299 8.32788H8.28249C7.57419 8.32788 7 8.90207 7 9.61037V13.4578C7 14.1661 7.57419 14.7403 8.28249 14.7403H12.1299C12.8382 14.7403 13.4124 14.1661 13.4124 13.4578V9.61037C13.4124 8.90207 12.8382 8.32788 12.1299 8.32788Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.5589 7.90688L16.8384 10.6274C16.3375 11.1283 16.3375 11.9403 16.8384 12.4412L19.5589 15.1617C20.0598 15.6626 20.8718 15.6626 21.3726 15.1617L24.0932 12.4412C24.5941 11.9403 24.5941 11.1283 24.0932 10.6274L21.3726 7.90688C20.8718 7.40604 20.0598 7.40604 19.5589 7.90688Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.1299 18.5878H8.28249C7.57419 18.5878 7 19.162 7 19.8703V23.7177C7 24.426 7.57419 25.0002 8.28249 25.0002H12.1299C12.8382 25.0002 13.4124 24.426 13.4124 23.7177V19.8703C13.4124 19.162 12.8382 18.5878 12.1299 18.5878Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.3898 18.5878H18.5424C17.8341 18.5878 17.2599 19.162 17.2599 19.8703V23.7177C17.2599 24.426 17.8341 25.0002 18.5424 25.0002H22.3898C23.0981 25.0002 23.6723 24.426 23.6723 23.7177V19.8703C23.6723 19.162 23.0981 18.5878 22.3898 18.5878Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  hySuccess: `<svg width="24" height="37" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0)">
<path d="M21.2968 10.8431C21.3783 11.3646 21.4199 11.9005 21.4199 12.4443C21.4199 18.1869 16.7651 22.8418 11.0225 22.8418C5.27986 22.8418 0.625 18.1869 0.625 12.4443C0.625 6.70174 5.27986 2.04688 11.0225 2.04688C12.7532 2.04688 14.3848 2.46917 15.8213 3.21779" stroke="#333333" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.22363 10.0449L11.0225 14.8438L23.8193 2.04688" stroke="#333333" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`,
  hyMailSuite: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25 7L19.2143 25L14.7143 17.2857L7 12.7857L25 7Z" fill="none" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M24.9996 7L14.7139 17.2857" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  hyCDP: `<svg width="24" height="38" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5 1.5V10.5H23.5C23.5 5.529 19.471 1.5 14.5 1.5Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.5 5.5C5.529 5.5 1.5 9.529 1.5 14.5C1.5 19.471 5.529 23.5 10.5 23.5C15.471 23.5 19.5 19.471 19.5 14.5H10.5V5.5Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
}
export const apps = [
  {
    icon: "icon-calendar-event-2",
    title: "hyTours",
    url: "https://hy.ly/tour-scheduler/"
  },
  {
    icon: "icon-edit-file",
    title: "hyForms",
    url: "https://my.hyly.us/mktg/tenants/1600476755109367157/landing_pages"
  },
  {
    icon: "icon-single-02",
    title: "hyCRM",
    url: "https://hy.ly/tour-scheduler/customer-relationship-management/"
  },
  {
    icon: "icon-chart-bar-32",
    title: "hyIQ",
    url: "https://hy.ly/multifamily-analytics/"
  },
  {
    icon: "icon-single-folded",
    title: "hySurvey",
    url: "https://hy.ly/property-comp-survey/"
  },
  {
    icon: "icon-event-confirm",
    title: "hyBlast",
    url: "https://hy.ly/agent-communications/"
  }
];

export const hubs = [
  {
    icon: "icon-home-2",
    title: "hyBeacon",
    url: "https://my.hyly.us/mktg/tenants/1600476755109367157/beacon/sources"
  },
  {
    icon: "icon-single-content-03",
    title: "Contacts",
    url: ""
  },
  {
    icon: "icon-apartment",
    title: "Sub-Orgs",
    url: ""
  },
  {
    icon: "icon-widget",
    title: "Automation",
    url: ""
  },
  {
    icon: "icon-folder-money",
    title: "Billing",
    url: ""
  },
  {
    icon: "icon-multiple",
    title: "Accounts",
    url: ""
  },
  {
    icon: "icon-phone",
    title: "Telephony",
    url: ""
  }
];

export const notAuthorized = [
  {
    icon: "icon-mail",
    title: "hyMail",
    subtitle: "Automated Multifamily Email",
    url: "https://hy.ly/multifamily-email/"
  },
  {
    icon: "icon-event-confirm",
    title: "hyBlast",
    subtitle: "Communications Made Easy",
    url: "https://hy.ly/agent-communications/"
  },
  {
    icon: "icon-sidebar",
    title: "hySite",
    subtitle: "Multifamily Website",
    url: "https://hy.ly/multifamily-website/"
  },
  {
    icon: "icon-layers-2",
    title: "hyALM",
    subtitle: "Autonomous Lifecycle Marketing",
    url: "https://hy.ly/multifamily-lifecycle-marketing/"
  },
  {
    icon: "icon-b-comment-2",
    title: "hyChat",
    subtitle: "Autonomous Facebook Chatterbot",
    url: "https://hy.ly/multifamily-facebook-messenger-bot/"
  }
];

export const appsAndHubs = [
  {
    id: "UHJvZHVjdC0xNTE5OTk0NTU0NDkxNTk1Njg5",
    name: "hyMail",
    url: "https://my.hyly.us/mktg/tenants/1510679501769740702/newsletters",
    authorized: true,
    appOrHub: "App",
    icon: "icon-mail"
  },
  {
    id: "UHJvZHVjdC0xNTE5OTk0NTQyMzgwOTc1NDQ5",
    name: "hyTours",
    url: "https://my.hyly.us/tours/1510679501769740702/setting/calendars",
    authorized: true,
    appOrHub: "App",
    icon: "icon-calendar-event-2"
  },
  {
    id: "UHJvZHVjdC0xNTMyMzM1MDU0NDE4Nzc0MjA4",
    name: "hyForms",
    url: "https://my.hyly.us/mktg/tenants/1510679501769740702/landing_pages",
    authorized: true,
    appOrHub: "App",
    icon: "icon-edit-file"
  },
  {
    id: "UHJvZHVjdC0xNTMzNDAwNzg0MDExMDY2Nzkw",
    name: "hyCRM",
    url: "https://my.hyly.us/crm/1510679501769740702/entries",
    authorized: true,
    appOrHub: "App",
    icon: "icon-single-02"
  },
  {
    id: "UHJvZHVjdC0xNTMyMzM1MDcxODczNjI1NTc5",
    name: "hySite",
    url: "https://my.hyly.us/sites/1515103520797991461/amenities",
    authorized: true,
    appOrHub: "App",
    icon: "icon-sidebar"
  },
  {
    id: "UHJvZHVjdC0xNTE5OTk0NTY0MTgyNjYyNDAy",
    name: "hyIQ",
    url: "https://my.hyly.us/iq/1510679501769740702/system_hymail_analytics",
    authorized: true,
    appOrHub: "App",
    icon: "icon-chart-bar-32"
  },
  {
    id: "UHJvZHVjdC0xNTk4NTI3NTU4NzMxMDU2NDYw",
    name: "hyBeacon",
    url: "https://my.hyly.us/mktg/tenants/1510679501769740702/beacon/sources",
    authorized: true,
    appOrHub: "App",
    icon: "icon-home-2"
  },
  {
    id: "UHJvZHVjdC0xNTIwMTUyMTI5MTMyMDczOTA2",
    name: "Contacts",
    url: "#",
    authorized: false,
    appOrHub: "Hub",
    icon: "icon-single-content-03"
  },
  {
    id: "UHJvZHVjdC0xNTMyMzM0NzUwNzAyOTgxMTU5",
    name: "Sub-Orgs",
    url: "https://my.hyly.us/sites/1510679501769740702/properties",
    authorized: true,
    appOrHub: "Hub",
    icon: "icon-apartment"
  },
  {
    id: "UHJvZHVjdC0xNTUzNjkzMTE4MDIxNjQwODYy",
    name: "Automation",
    url: "#",
    authorized: false,
    appOrHub: "Hub",
    icon: "icon-widget"
  },
  {
    id: "UHJvZHVjdC0xNTk4NTI3NTU5MzQ2NzEzODMw",
    name: "Billing",
    url: "#",
    authorized: false,
    appOrHub: "Hub",
    icon: "icon-folder-money"
  },
  {
    id: "UHJvZHVjdC0xNTIwMTUyMTQ4NjU4ODYwOTk0",
    name: "Accounts",
    url: process.env.REACT_APP_ACCOUNTS_LINK,
    authorized: true,
    appOrHub: "App",
    icon: "icon-multiple"
  },
  {
    id: "UHJvZHVjdC0xNTIwMTUyMTQ4NjU4ODYwOTk1",
    name: "hySurvey",
    url: process.env.REACT_APP_HYSURVEY_LINK,
    authorized: true,
    appOrHub: "App",
    icon: "icon-multiple"
  },
  {
    id: "UHJvZHVjdC0xNjExNTYyMDM0OTEzMTM1MDIw",
    name: "hyChat",
    url: "https://my.hyly.us/chat/1510679501769740702/integrations/facebook",
    authorized: true,
    appOrHub: "App",
    icon: "icon-b-comment-2"
  },
  {
    id: "UHJvZHVjdC0xNjM5MzI0NTIwMDY0MDkwOTc0",
    name: "hyBlast",
    url: process.env.REACT_APP_LINK,
    authorized: true,
    appOrHub: "App",
    icon: "icon-event-confirm"
  },
  {
    id: "UHJvZHVjdC0xNjUwNjk0NTE0MjUwMjE0MzIx",
    name: "hyALM",
    url: process.env.REACT_APP_HYALM_LINK,
    authorized: true,
    appOrHub: "App",
    icon: "icon-layers-2"
  },
  {
    id: "UHJvZHVjdC0xNjQ5NDY4MjUyNjYwOTczNzYz",
    name: "Telephony",
    url: "https://my.hyly.us/crm/1510679501769740702/setting/sms_prompts",
    authorized: true,
    appOrHub: "Hub",
    icon: "icon-phone"
  },
  {
    id: "djhfusdhfus77",
    name: "hyEvents",
    icon: "icon-calendar-date-2",
    url: "https://hyevents-qa.hyly.app",
    appOrHub: "App",
    authorized: true,
    id: "UHJvZHVjdC0xNzAxNTIyMTczNjIxMzIyNDY1",
    name: "hyCXP",
    url: "https://hycxp-qa.hyly.app",
    svg: true,
    icon: icon.hyCxp
  },
  {
    appOrHub: "App",
    authorized: true,
    id: "UHJvZHVjdC0xNjk5OTk2MzgwNDY0MzMwMjcy",
    name: "hySuccess",
    url: "https://hysuccess-qa.hyly.app",
    svg: true,
    icon: icon.hySuccess
  },
  {
    id: "UHJvZHVjdC0xNjkxMTk4MjEzNzcxMjc2NjY2",
    name: "hyEvents",
    icon: "icon-calendar-date-2",
    url: "https://hyevents-qa.hyly.app",
    appOrHub: "App",
    authorized: true
  },
  {
    appOrHub: "App",
    authorized: true,
    id: "UHJvZHVjdC0xNjk3ODE0NDEyODc2NTY3ODc5",
    name: "hyRaf",
    url: "https://hyRaf-qa.hyly.app",
    svg: true,
    icon: icon.hyRaf
  },
  {
    appOrHub: "App",
    authorized: true,
    id: "UHJvZHVjdC0xNjk3ODE0NDEyODc2NTY3ODc5",
    name: "hyMail Suite",
    url: "https://hyMail-qa.hyly.app",
    svg: true,
    icon: icon.hyMailSuite,
  },
  {
    appOrHub: "App",
    authorized: true,
    id: "UHJvZHVjdC0xNjk3ODE0NDEyODc2NTY3ODc5",
    name: "hyCDP",
    url: "https://hycdp-qa.hyly.app/",
    svg: true,
    icon: icon.hyCDP,
  },
  {
    id: "UHJvZHVjdC0xNjM5MzI0NTIwMDY0MDkwOTc0",
    name: "Blasts",
    url: process.env.REACT_APP_LINK,
    authorized: true,
    appOrHub: "App",
    icon: "icon-mail",
  },
  {
    id: "UHJvZHVjdC0xNjUwNjk0NTE0MjUwMjE0MzIx",
    name: "Drips",
    url: process.env.REACT_APP_HYALM_LINK,
    authorized: true,
    appOrHub: "App",
    icon: "icon-layers-2",
  },
  {
    id: "UHJvZHVjdC0xNjk5OTk2MzgwNDY0MzMwMjcy",
    name: "Success Center",
    url: "https://hysuccess-qa.hyly.app",
    authorized: true,
    appOrHub: "App",
    svg: true,
    icon: icon.hySuccess,
  },
  {
    id: "UHJvZHVjdC0xNjkxMTk4MjEzNzcxMjc2NjY2",
    name: "Events",
    icon: "icon-calendar-date-2",
    url: "https://hyevents-qa.hyly.app",
    appOrHub: "App",
    authorized: true,
  },
  {
    id: "UHJvZHVjdC0xNjk3ODE0NDEyODc2NTY3ODc5",
    name: "Refer-a-Friend",
    url: "https://hyRaf-qa.hyly.app",
    svg: true,
    icon: icon.hyRaf,
    appOrHub: "App",
    authorized: true,
  },
];
